import React, { Fragment, useState } from "react";
import moment from "moment-hijri";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "تحويل التاريخ من ميلادي الى هجري";
const DESCRIPTION =
  "تحويل التاريخ من ميلادي لهجري عن طريق ادخال التاريخ بالميلادي ومعرفة ما يقابله بالهجري بواسطة محول التاريخ الإلكتروني";
const KEYWORDS =
  "تحويل التاريخ, ميلادي, هجري, ادخال التاريخ, محول التاريخ الإلكتروني, تقابل, بالميلادي, بالهجري, معرفة, تحويل تاريخ ميلادي لهجري, إلكتروني, تحويل تاريخ";
const OG_URL = "https://do-calculate.com/calculator/ar/gregorian_to_hijri";

// Updated Month List with names and numbers
const GREGORIAN_MONTHS = [
  "كانون الثاني", "شباط", "آذار", "نيسان", "أيار", "حزيران",
  "تموز", "آب", "أيلول", "تشرين الأول", "تشرين الثاني", "كانون الأول"
];

function ConversionToHijri() {
  const [dateInputs, setDateInputs] = useState({ day: "", month: "", year: "" });
  const [hijriDate, setHijriDate] = useState("");
  const [showError, setShowError] = useState(false);

  const convertToHijri = () => {
    const { day, month, year } = dateInputs;

    if (!day || !month || !year) {
      setShowError(true);
      setHijriDate("");
      return;
    }

    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const isValidDate = moment(formattedDate, "YYYY-MM-DD", true).isValid();

    if (isValidDate && parseInt(year) > 1937) {
      const convertedDate = moment(formattedDate, "YYYY-MM-DD").format("iYYYY-iM-iD");
      setHijriDate(convertedDate);
      setShowError(false);
    } else {
      setHijriDate("");
      setShowError(true);
    }
  };

  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light ">
            <div className="row ">
              <div className="p-3">
                <p>
                  هذه الحاسبة عبر الإنترنت توفر وسيلة سهلة لتحويل التواريخ من
                  التقويم الميلادي إلى الهجري. ببساطة، يقوم المستخدم بتحديد
                  اتجاه التحويل وإدخال التاريخ الميلادي المراد تحويله. بعد ذلك،
                  تقوم الحاسبة بتنفيذ العملية بشكل تلقائي وتقديم التاريخ المحول
                  بالتقويم الهجري. يُظهر النتيجة بطريقتين: الأولى بتنسيق رقمي،
                  والثانية بتقديم اليوم والشهر والسنة بشكل مفصل. تتيح هذه
                  الحاسبة للمستخدمين الحصول بسرعة وبدقة على التواريخ المحولة بين
                  التقاويم الميلادي والهجري، مما يسهل تنظيم الأوقات والأحداث في
                  الحياة اليومية.
                </p>
                <br />
                يمكنك من خلال هذه الحاسبة ادخال التاريخ بصيغة الميلادي وستقوم
                بعملية تحويل التاريخ المدخل إلى ما يقابله في التاريخ الهجري
                العربي حسب تقويم ام القرى
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row ">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة تحويل التاريخ من ميلادي الى هجري
                </div>
                <div>
                  <label
                    style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}
                  >
                    أدخل التاريخ الميلادي
                  </label>
                </div>

                {/* Day, Month, Year Inputs in one row */}
                <div className="row">
                  <div className="col-md-4">
                    <label  style={{ fontSize: "14px" }}>اليوم</label>
                    <select
                      className="form-control"
                      value={dateInputs.day}
                      onChange={(e) => setDateInputs({ ...dateInputs, day: e.target.value })}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">اليوم</option>
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                        <option key={day} value={day}>{day}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label  style={{ fontSize: "14px" }}>الشهر</label>
                    <select
                      className="form-control"
                      value={dateInputs.month}
                      onChange={(e) => setDateInputs({ ...dateInputs, month: e.target.value })}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">الشهر</option>
                      {GREGORIAN_MONTHS.map((month, index) => (
                        <option key={index} value={index + 1}>
                          {index + 1} - {month}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label  style={{ fontSize: "14px" }}>السنة</label>
                    <select
                      className="form-control"
                      value={dateInputs.year}
                      onChange={(e) => setDateInputs({ ...dateInputs, year: e.target.value })}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">السنة</option>
                      {Array.from(
                        { length: new Date().getFullYear() - 1936 },
                        (_, i) => new Date().getFullYear() - i
                      ).map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="col text-center">
                    <br />
                    <button
                      className="btn btn-success"
                      onClick={convertToHijri}
                      style={{
                        fontSize: "17px",
                        marginTop: "25px",
                        marginBottom: "10px",
                        padding: "10px 40px"
                      }}
                    >
                      احسب
                    </button>
                  </div>
                  <div className="row">
                    {showError && (
                      <p style={{ color: "red", textAlign: "center" }}>
                        الرجاء إدخال تاريخ صحيح بين 1938 والتاريخ الحالي
                      </p>
                    )}
                    <div className="col">
                      {hijriDate && !showError && (
                        <Fragment>
                          <hr style={{ margin: "1rem 0" }} />
                          <div className="table-responsive" style={{ marginBottom: "15px" }}>
                            <table className="table table-bordered" style={{ marginBottom: "0" }}>
                              <thead style={{ backgroundColor: "#4caf50", color: "white" }}>
                                <tr>
                                  <th style={{ textAlign: "center", fontSize: "20px", fontWeight: "normal" }}>
                                    التاريخ المدخل
                                  </th>
                                  <th style={{ textAlign: "center", fontSize: "20px", fontWeight: "normal" }}>
                                    يوافق بالتاريخ الهجري
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td style={{ textAlign: "center", fontSize: "18px" }}>
                                    {`${dateInputs.day}-${dateInputs.month}-${dateInputs.year}`}
                                  </td>
                                  <td style={{ textAlign: "center", fontSize: "18px" }}>
                                    {hijriDate}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
            <div className="row">
              <RelatedLinks />
              <br />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                تحول التاريخ الميلادي الى هجري
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    تحول التاريخ الميلادي الى هجري أون لاين
                  </h2>{" "}
                </u>
                <br />
                <p>
                  تُعتبر الحاسبة عبر الإنترنت وسيلة فعالة لتحويل التواريخ من
                  التقويم الميلادي إلى الهجري. على سبيل المثال، يمكن للتطبيق
                  تحويل تاريخ إصدار جواز سفر من التاريخ الميلادي، حيث يُحدد
                  اليوم عشرون، والشهر الثالث، والسنة ألفين وعشرين، ليعرض التاريخ
                  المحول بالتقويم الهجري. في سياق آخر، يُستخدم التطبيق لتسجيل
                  تاريخ انتهاء صلاحية بطاقة ائتمان، حيث يكون اليوم خامس عشر،
                  والشهر العاشر، والسنة ألفين وعشرون بالتاريخ الميلادي. يتيح
                  تحويل التواريخ عبر الإنترنت إمكانية تنظيم الأوقات والمواعيد
                  بسهولة، سواء كان ذلك لغرض السفر أو التمويل، مع إمكانية الوصول
                  إلى النتائج بشكل سريع ودقيق في أي وقت ومن أي مكان في العالم.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>خطوات تحويل التاريخ</h2>
                </u>
                <br />
                <p>
                  محول التاريخ من هجري الى ميلادي والعكس بطريقة صحيحة إن شاء
                  الله ، فقط قم بإختيار طريقة التحويل ، مثلاً اذا كنت تريد تحويل
                  تاريخ الهجري الى تاريخ ميلادي فقط قم بالضغط على جملة تحويل
                  التاريخ الهجري ، ثم أختار اليوم والشهر والسنة ثم تحويل ، بعدها
                  سيقوم الموقع تلقائياً بتحديد التاريخ الصحيح حسب التقويم الذي
                  قمت بإختياره عن طريق تغيير الدولة أو اختيار تقويم أم القرى،
                  وكذلك الأمر ينطبق على تحويل التاريخ من ميلادي الى هجري بإتباع
                  نفس الخطوات السابقة.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    تطبيق عملي ومثال لتحويل التواريخ من التقويم الميلادي إلى
                    الهجري{" "}
                  </h2>
                </u>
                <br />
                <p>
                  تطبيق فعّال لتحويل التواريخ من التقويم الميلادي إلى الهجري،
                  حيث يُستعرض المثال تاريخ ميلاد شخص وُلد في دولة أجنبية بتاريخ
                  15/9/2020. يتعين تحويل هذا التاريخ إلى التقويم الهجري لتسجيل
                  المولود في المملكة العربية السعودية، على سبيل المثال. بإدخال
                  يوم 15 وشهر 9 وسنة 2020 في نظام التحويل، يظهر التاريخ المحول
                  بصيغ متنوعة مثل 1442-01-28 أو 28 محرم 1442، وبذلك يُكتمل العمل
                  بنجاح.
                </p>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}

export default ConversionToHijri;